import {Component,Inject,Input, Output, EventEmitter} from 'ng-metadata/core';
import { ServiceButtonService } from './serviceButton.service';
import {OPAC_TAB} from './opac.directive';
import {ChangeTabEvent} from './opac.directive';

const _get= require('lodash/get');

@Component({
	selector: 'prm-service-button',
	templateUrl: 'components/search/fullView/getit/opac/service-button.html',
})
export class PrmServiceButton{

	@Input() public service;
	@Input() public parentTab : OPAC_TAB;
    @Input() public requestParameters;
    @Input() public envUrl;

	@Output() private changeTabEvent: EventEmitter<ChangeTabEvent>= new EventEmitter();
	private buttonAriaLabel : string;

	constructor(private serviceButtonService: ServiceButtonService,
				@Inject('actionIcons') public actionIcons,
				@Inject('$translate') private $translate) {
	}

	ngOnInit() {
		this.$translate.onReady().then(() => {
			this.buttonAriaLabel = (this.$translate.instant(this.service.type) + " " + _get(this.requestParameters, 'itemdescription', '')).trim();
		});
	}

	public getServiceDetails() {
		if(this.service['service-type'] === 'OvL'){
			let link:string = this.service['link-to-service'];
			if(link !== undefined) {
				window.open(link, '_blank');
			}
		} else {
			if(this.envUrl){
				this.service['link-to-service'] += "&envURL="+encodeURIComponent(this.envUrl);
			}
			this.serviceButtonService.makeIlsRequest(this.service, this.requestParameters)
				.then((res)=> {
					let eventData = {
						referer: this.parentTab,
						dest: OPAC_TAB.REQUEST
					};
					this.changeTabEvent.emit(eventData);
				});
		}
	}
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/serviceButton.directive.ts